export default __webpack_public_path__ + "static/media/archived_list.7356259e.png";